import * as React from "react";
import styled from "@mui/material/styles/styled";

//region [[ Styles ]]

const ThemeImageView = styled("div")(({ theme }) => ({
  width: "max-content",
  height: "max-content",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ThemeImageProps {
  source: string;
  className?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PatientThemeImage = ({ ...props }: ThemeImageProps) => {
  let src = props.source;

  try {
    src = require("patient/src/assets/" + props.source);
  } catch (e) {
    if (src?.startsWith?.("http") || src?.startsWith?.("https")) {
      src = props.source;
    }
    //console.error(e);
  }
  return (
    <ThemeImageView>
      <img src={src} alt="" className={props.className} />
    </ThemeImageView>
  );
};
